import { fieldsReducer } from 'screens/Property/helpers/propertyReducerHelpers';

type Feature = {
  type: string;
  geometry?: unknown;
  properties: { id?: string; [key: string]: unknown };
};

type FeatureCollection = { type: string; features: Feature[] };

type SavedField = {
  id: string;
  propertyId?: string;
  geometry?: unknown;
  cropzones?: unknown[];
  [key: string]: unknown;
};

/**
 * The landing's cached shapes with `field` added, or replaced if it was
 * already there, built as the landing builds them. Used after saving a field
 * so the next screen's map (e.g. Add Crop Zone) shows it as background.
 */
const upsertFieldGeoJson = (
  field: SavedField,
  allFFTGeoJson: FeatureCollection
): FeatureCollection => {
  const reduce = fieldsReducer(field.propertyId) as (
    acc: Feature[],
    item: SavedField
  ) => Feature[];
  const [fieldFeature] = reduce([], { ...field, cropzones: [] });
  return {
    type: allFFTGeoJson.type,
    features: [
      ...allFFTGeoJson.features.filter(
        feature => feature.properties?.id !== field.id
      ),
      fieldFeature
    ]
  };
};

export default upsertFieldGeoJson;
